import { ModuleDiagnosticInfo } from "../../Model/Diagnostic";

export enum EDiagnosticAction {
  UPDATE_DIAGNOSTIC = "UPDATE_DIAGNOSTIC",
}

export interface DiagnosticAction {
  type: EDiagnosticAction;
  moduleDiagnosticInfo: ModuleDiagnosticInfo;
}

export function updateDiagnostic(moduleDiagnosticInfo: ModuleDiagnosticInfo): DiagnosticAction {
  return {
    type: EDiagnosticAction.UPDATE_DIAGNOSTIC,
    moduleDiagnosticInfo: moduleDiagnosticInfo,
  };
}
